<template>
  <transition name="slide">
    <div class="project-update">
      <div class="wizard-toolbar">
        <div class="grid-2">
          <div class="progress-step-1 done">
            <div class="bar"></div>
            <p>{{ $t('ui.project_wizard.step1-title') }}</p>
          </div>

          <div class="progress-step-2 done">
            <div class="bar"></div>
            <p>{{ $t('ui.project_wizard.step2-title') }}</p>
          </div>
        </div>
      </div>

      <div class="project-created">
        <img src="../../../../assets/project-created.svg">
        <h3>{{ $t('ui.project_wizard.success-title') }}</h3>
        <p>{{ $t('ui.project_wizard.success-subtitle') }}</p>
      </div>

      <div class="actions wizard-footer">
        <div v-if="shouldShowDefaultActions">
          <router-link :to="{ name: 'project_leads', params: { id: this.item.id.toString() }}">
            <a class="cancel">{{ $t('ui.pages.project-capture-leads') }}</a>
          </router-link>

          <router-link :to="{ name: 'content_manager'}">
            <button class="btn btn-primary btn-flat btn-save">{{ $t('ui.pages.project-create-content') }}</button>
          </router-link>
        </div>

        <div v-else class="actions">
          <a :href="talentKitLink">
            <button class="btn btn-primary btn-flat btn-save">
              {{ $t(talentButtonText) }}
            </button>
          </a>

          <router-link :to="{ name: 'project_leads', params: { id: this.item.id.toString() }}">
            <button class="btn btn-primary btn-flat btn-save">{{ $t('ui.pages.project-capture-leads') }}</button>
          </router-link>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    item: {
      type: Object
    }
  },
  computed: {
    shouldShowDefaultActions() {
      let isTalents = this.$store.getters.getCurrentPlanIsTalent
      return !isTalents
    },
    customKit() {
      return this.$store.getters.getProjectWizardCustomBusinessKit
    },
    talentKitLink() {
      let link = this.$store.getters.getBusinessKitLink
      return link
    },
    talentButtonText() {
      if (this.customKit) {
        return 'ui.pages.project-create-talentkit'
      } else {
        return 'ui.pages.project-view-talentkit'
      }
    }
  }
}
</script>

<style lang="scss">

.wizard.step-3 {
  .project-created {
    padding: 40px 30px 0px 30px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    h3 {
      margin-bottom: 0;
      margin-top: 2em;
      font-weight: $font-medium;
      font-size: 22px;
      padding: 0 2em;
      line-height: 26px;
    }

    p {
      color: #6A7A8A;
      margin-bottom: 2.5em;
      margin-top: .5em;
    }
  }
  .actions {
    justify-content: center;
    .btn {
      margin: 0 .5em;
    }
  }
}
@media(max-width: 575px) {

  .wizard.step-3 {
    padding-top: 0;
  }
  .wizard.step-3 .project-created h3 {
    padding: 0;
    margin: 1em 0;
  }

  .wizard.step-3 .project-created {
    padding: 40px 30px 0 30px;
  }

}
</style>



// WEBPACK FOOTER //
// Success.vue?295ac6c4